export default __webpack_public_path__ + "static/media/app-store-badge.10bbf954.svg";